export default "__VITE_PUBLIC_ASSET__94de8d25__"